(function ( $ ) {
	
  var menus;

  $(document).ready(function() {

  	menus = $('.jr-menu');

  	menus.each(function() {



  		// Collapse Menu
  		var $this = $(this);
  		var $button = $this.find('.collapse-menu-container a');
  		var collapseBreakpoints = $this.data('collapse-menu-active');
  		var $menu = $this.find('.menu');
		  var $submenus = $this.find('.menu-item-has-children');
		  
		  if ( typeof collapseBreakpoints === 'undefined' ) {
			return true;
		  }



  		$button.click(function(e) {

  			e.preventDefault();

  			if (collapseBreakpoints.indexOf(Foundation.MediaQuery.current) !== -1) {


  				$this.find('.slick-slider').slick('setPosition');

  				if ($menu.is(':visible')) {
	  				$menu.slideUp('slow').removeClass('collapse-menu-active');
  				} else {
					
  					$this.addClass('collapse-menu-active');
  					$menu.hide();
  					$menu.slideDown('slow');
  					
  				}

  				$this.find('.slick-slider').slick('setPosition');

  			}

  		});

  		$submenus.find('> a').click(function(e){

  			e.preventDefault();

  			var $this = $(this);
			var subMenuWrapper = $this.next('.sub-menu-wrapper');

			if ( subMenuWrapper.length === 0 ) {
				return;
			}

  			$this.parent().toggleClass('active');

  			if ( subMenuWrapper.is(':visible') ) {
  				subMenuWrapper.slideUp('slow', function() {
  					$(this).removeAttr('style');
  				});
  			} else {
  				subMenuWrapper.slideDown('slow');
  				subMenuWrapper.find('.slick-slider').slick('setPosition');
  			}
  			

  		});


        $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize){

        	$menu.removeAttr('style');
        	$submenus.next('.sub-menu-wrapper').removeAttr('style');

            if (collapseBreakpoints.indexOf(newSize) === -1) {
               $this.removeClass('collapse-menu-active');
               
            }

        });


  	});

  });
 
}( jQuery ));



